import { getHttp } from '@nucleus-commerce/api-client/transport';

import { toApiStatus, type ApiStatus, type Health, type Readiness } from './status';

// Probes answer fast or not at all; the transport's 30 s default would freeze the dots.
const PROBE_TIMEOUT_MS = 5_000;

/**
 * GET /health and /ready are outside the generated /platform/v1 client, so they go through the
 * configured axios instance directly. /ready answers 503 when degraded and that body is still
 * the payload we want, so 503 is accepted as a response rather than an error.
 */
export const systemApi = {
  health: async (): Promise<Health> => {
    const { data } = await getHttp().get<Health>('/health', { timeout: PROBE_TIMEOUT_MS });
    return data;
  },
  readiness: async (): Promise<Readiness> => {
    const { data } = await getHttp().get<Readiness>('/ready', {
      timeout: PROBE_TIMEOUT_MS,
      validateStatus: (status) => status === 200 || status === 503,
    });
    return data;
  },
  status: async (): Promise<ApiStatus> => {
    const [health, readiness] = await Promise.allSettled([
      systemApi.health(),
      systemApi.readiness(),
    ]);
    return toApiStatus(health, readiness, new Date());
  },
};
